import { render, staticRenderFns } from "./ClassicBooks.vue?vue&type=template&id=51545716&scoped=true"
import script from "./ClassicBooks.vue?vue&type=script&lang=js"
export * from "./ClassicBooks.vue?vue&type=script&lang=js"
import style0 from "./ClassicBooks.vue?vue&type=style&index=0&id=51545716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51545716",
  null
  
)

export default component.exports